import BlogPhoto1 from "../../images/blog/howtobuild.webp";
import BlogPhoto2 from "../../images/blog/Blog1.webp";
import BlogPhoto3 from "../../images/blog/Blog3.webp";
import BlogPhoto4 from "../../images/blog/Blog4.webp";
import BlogPhoto5 from "../../images/blog/Blog5.webp";
import BlogPhoto6 from "../../images/blog/Blog6.webp";
import BlogPhoto7 from "../../images/blog/Blog7.png";
import BlogPhoto8 from "../../images/blog/Blog8.png";
import BlogPhoto9 from "../../images/blog/Blog9.png";
import BlogPhoto10 from "../../images/blog/Blog10.png";
import BlogPhoto11 from "../../images/blog/Blog11.svg";
import BlogPhoto12 from "../../images/blog/Blog12.svg";

export const data = [
  {
    id: 12,
    link: "blog/12",
    img: BlogPhoto12,
    title:
      "Celebrating Excellence: A Year of Gratitude for the Expedient Staffing Team",
    subtext:
      "Join us in reflecting on a year of accomplishments with Expedient Staffing Solutions.",
  },
  {
    id: 11,
    link: "blog/11",
    img: BlogPhoto11,
    title: "Agility: The Key to Thriving in the Ever-Evolving Talent Market",
    subtext:
      "The more trusted you are as a staffing partner, the more agile you must be.",
  },
  {
    id: 10,
    link: "blog/10",
    img: BlogPhoto10,
    title:
      "How Customers Benefit From The Skills Of MWBE Leaders | Expedient Staffing",
    subtext:
      "Hiring MWBE owned companies is much more than just a signal of diversity. Learn how customers can benefit from the unique skills that these leaders have to offer.",
  },
  {
    id: 9,
    link: "blog/9",
    img: BlogPhoto9,
    title: "Flipping the Script:",
    subtitle:
      "Driving performance for NYC while Empowering MWBEs as Prime Suppliers",
    subtext:
      "Explore how empowering Minority and Women Owned Business Enterprises (MWBE) as prime supplier can drive performance for New York City. Learn about the benefits of flipping the script and how it can lead to better results.",
  },
  {
    id: 8,
    link: "blog/8",
    img: BlogPhoto8,
    title:
      "Tips for Doing Business with State and Local Government as an MWBE – A WBE Founder’s View",
    subtext:
      "Insights from a successful WBE founder on how to build relationships and secure deals with state and local government leaders",
  },
  {
    id: 7,
    link: "blog/7",
    img: BlogPhoto7,
    title: "Rethinking the Interview Process:",
    subtitle: "The Benefits of Aptitude-Based Interviews versus Simply Skills",
    subtext:
      "In a recent article, Linkedin’s Talent Blog noted that there is a change in the way employers interview and hire...",
  },
  {
    id: 6,
    link: "blog/6",
    img: BlogPhoto6,
    title: "Promotion in 2023? Three tips that can help get you there.",
    subtext:
      "Regardless of the economic climate, there are certain themes that lead to employees being promoted. Here's what you need to know. ",
  },
  {
    id: 5,
    link: "blog/5",
    img: BlogPhoto5,
    title:
      "Developing a skill – one CEO’s mission – and why it matters to the economy | Expedient Staffing",
    subtext:
      "Gina Herrera, Chief Executive Officer of Expedient Staffing, is committed to the company's focus on developing skills. This benefits the employee and the broader economy.",
  },
  {
    id: 4,
    link: "blog/4",
    img: BlogPhoto4,
    title: "Top Tips:",
    subtitle:
      "Fast Improvements to the Recruiting Process That Can Improve IT Hiring ",
    subtext:
      "Looking to improve your IT hiring process? Check out these top tips for fast improvement!...",
  },
  {
    id: 3,
    link: "blog/3",
    img: BlogPhoto3,
    title: "The Future of Call Centers:",
    subtitle:
      "Improvements That Benefit Employee Satisfaction and the Customer Experience",
    subtext:
      "Peruse open jobs on LinkedIn or Indeed and you’ll see titles that didn’t exist even a few years ago...",
  },
  {
    id: 2,
    link: "blog/2",
    img: BlogPhoto2,
    title:
      "A Staffing Company's Success to Attracting and Retaining Top Talent:",
    subtitle: "Culture, Training, personal & Professional Development",
    subtext:
      "When it comes to the success of your company, culture is key. From creating a positive workplace environment to...",
  },
  {
    id: 1,
    link: "blog/1",
    img: BlogPhoto1,
    title: "How To Build Candidate Relationships, Not “Pipelines”",
    subtext:
      "Consider this…70% of the workforce is passive talent. With over 11 million open jobs...",
  },
];
